import { Box } from '@jfs/ui-new'
import { FC, useEffect } from 'react'
import { Animated, ViewStyle } from 'react-native'

interface LoaderProps {
  state: any
}
const HorizontalLoader: FC<LoaderProps> = ({ state }: LoaderProps) => {
  const defaultValue = 1
  const bgAnimation = new Animated.Value(defaultValue)
  const horizontalAnimation = bgAnimation.interpolate({
    inputRange: [0, 1],
    outputRange: ['0%', `${state}%`],
  })
  const transFormStyle = {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    borderRadius: 10,
    height: 2,
    backgroundColor: 'blue',
  } as ViewStyle

  useEffect(() => {
    Animated.timing(bgAnimation, {
      toValue: 1,
      duration: 200,
      useNativeDriver: false,
    }).start()
  }, [bgAnimation])
  const width = horizontalAnimation
  return (
    <Box width={200} height={2} backgroundColor={'SECONDARY_GREY'} borderRadius={10}>
      <Animated.View testID={'horizontalLoaderAnimatedView'} style={{ ...transFormStyle, width }} />
    </Box>
  )
}

export { HorizontalLoader }
